<template>
  <div>
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <div class="filters">
        <el-form
          :inline="true"
          label-width="50px"
          label-position="left"
          @submit.native.prevent="filter.pageNum=1;toQuery()"
        >
          <el-form-item :label="$t('common.btn.query')">
            <el-input
              v-model="filter.likeName"
              no="queryInput"
              :placeholder="$t('common.tips.fuzzySearch')"
              style="width:310px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
        <el-button no="new" type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
        <el-button no="edit" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
        <el-button no="delete" size="mini" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid">
      <cargo-ag-grid
        ref="branchFleet"
        no="grid"
        config-module="1010028"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        v-show="total>0"
        no="pagination"
        config-module="1010028"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="500px"
      @close="editDialog.visible=false"
    >
      <!--编辑弹窗-->
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item required :label="'车队代码'">
            <el-input v-model="editDialog.form.fleetCode" no="fleetCode" />
          </el-form-item>
          <el-form-item required :label="'车队分类'">
            <el-select v-model="editDialog.form.fleetType" no="fleetType" placeholder="请选择车队分类">
              <el-option label="分类1" value="1" />
              <el-option label="分类2" value="2" />
            </el-select>
          </el-form-item>
          <el-form-item required :label="'车队名称'">
            <el-input v-model="editDialog.form.fleetName" no="fleetName" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import {
  deleteBranchFleet,
  getBranchFleetList,
  saveBranchFleet
} from '@/api/basicData/branchFleet'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'BranchFleet',
  data() {
    return {
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          filter: true
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: '车队代码',
          field: 'fleetCode',
          width: 200
        },
        {
          headerName: '车队分类',
          field: 'fleetType',
          width: 200,
          cellRenderer: function(params) {
            if (params.value === '1') {
              return '分类1'
            } else if (params.value === '2') {
              return '分类2'
            }
            return params.value
          }
        },
        {
          headerName: '车队名称',
          field: 'fleetName',
          width: 200
        }
      ],
      rowData: null,
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          fleetCode: '',
          fleetType: '',
          fleetName: ''
        }
      }
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  created() {
  },
  methods: {
    onShow() {
      if (this.rowData === null) {
        this.rowData = []
        this.toQuery()
      }
    },
    toQuery() {
      const self = this
      const loading = getLoading()
      getBranchFleetList(self.filter).then(res => {
        if (self.gridApi) {
          self.gridApi.setRowData(res.data.list)
        } else {
          self.rowData = res.data.list
        }
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
      }).finally(() => loading.close())
    },
    showEditDialog(isNew) {
      // 新建
      if (isNew) {
        this.editDialog.form = {
          uuid: '',
          fleetCode: '',
          fleetType: '',
          fleetName: ''
        }
        this.editDialog.title = this.$t('CargoMsg.Cargo_NewTo') + '支线车队'
      } else {
        // 编辑
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...rows[0] }
        this.editDialog.title = this.$t('CargoMsg.Cargo_EditTo') + '支线车队'
      }
      this.editDialog.visible = true
    },
    save() {
      const self = this
      const form = self.editDialog.form
      if (!form.fleetCode.trim()) {
        self.$message.warning('车队代码不能为空')
        return
      }
      if (!form.fleetType.trim()) {
        self.$message.warning('车队分类不能为空')
        return
      }
      if (!form.fleetName.trim()) {
        self.$message.warning('车队名称不能为空')
        return
      }
      const loading = getLoading()
      saveBranchFleet(form).then(res => {
        if (!form.uuid) {
          self.filter.pageNum = 1
        }
        self.toQuery()
        self.editDialog.visible = false
        self.$message.success(self.$t('common.tips.saveSuccess'))
      }).finally(() => loading.close())
    },
    remove() {
      const self = this
      const rows = self.gridApi.getSelectedRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const uuids = rows.map(row => row.uuid)
        const loading = getLoading()
        deleteBranchFleet(uuids).then(res => {
          self.filter.pageNum = 1
          self.toQuery()
          self.$message.success(self.$t('common.tips.deleteSuccess'))
        }).finally(() => loading.close())
      }).catch(() => {
      })
    }
  }
}
</script>

<style>

</style>
